import normalizeText from '@/lib/normalizeText.js';

const buildAppMetadataLookup = (items = []) => {
  const lookup = new Map();

  for (const item of Array.isArray(items) ? items : []) {
    const appId = normalizeText(item?.id);
    const appSlug = normalizeText(item?.slug).toLowerCase();

    if (appId) {
      lookup.set(appId, item);
    }

    if (appSlug) {
      lookup.set(appSlug, item);
    }
  }

  return lookup;
};

const resolveAppMetadataForActivity = ({ appMetadataLookup, appId, appSlug }) => {
  const safeAppId = normalizeText(appId);
  const safeAppSlug = normalizeText(appSlug).toLowerCase();

  if (safeAppId && appMetadataLookup.has(safeAppId)) {
    return appMetadataLookup.get(safeAppId);
  }

  if (safeAppSlug && appMetadataLookup.has(safeAppSlug)) {
    return appMetadataLookup.get(safeAppSlug);
  }

  return null;
};

export { buildAppMetadataLookup, resolveAppMetadataForActivity };
